export default __webpack_public_path__ + "static/media/img--exterior-facade.ea70c76a.jpg";